import {
  StickyAppBar,
  GenButton,
} from '@pinnacleautomotive/clarity-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../../../common/enums/enums';

const SurveyFooter = ({ data, isLoading, onOpenSubmitQuality }) => {
  const { t } = useTranslation(['orders']);
  return !isLoading && !data?.qualitySurvey ? (
    <StickyAppBar
      display={data?.step === ProcessStep.DONE}
      title={t('survey.woDetailFooter.title')}
      subtitle={t('survey.woDetailFooter.subtitle')}
      buttons={[
        <GenButton
          text={t('survey.woDetailFooter.button')}
          variant="contained"
          color="primary"
          onClick={onOpenSubmitQuality}
        />,
      ]}
    />
  ) : null;
};

export default SurveyFooter;
